const STORAGE_KEY = 'lane-control:lane-navigation-order'
let currentOrder: string[] | null = null

export function saveLaneNavigationOrder(ids: readonly string[]): void {
  currentOrder = [...new Set(ids.filter(Boolean))]
  try {
    const value = JSON.stringify(currentOrder)
    if (sessionStorage.getItem(STORAGE_KEY) !== value) sessionStorage.setItem(STORAGE_KEY, value)
  } catch { /* The current list still works when storage is unavailable. */ }
}

export function adjacentLaneId(
  currentId: string,
  direction: -1 | 1,
  availableIds: readonly string[],
): string | null {
  let order = currentOrder
  if (!order) {
    try {
      const stored: unknown = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null')
      if (Array.isArray(stored)) order = stored.filter((id): id is string => typeof id === 'string')
    } catch { /* No valid saved list. */ }
  }
  const available = new Set(availableIds)
  const ids = [...new Set(order ?? [])].filter((id) => available.has(id))
  const index = ids.indexOf(currentId)
  if (index < 0 || ids.length < 2) return null
  return ids[(index + direction + ids.length) % ids.length] ?? null
}
